"use strict";
/**
 * Base Workflow Interface for man-core.
 * Orchestrates multi-step business use cases end-to-end.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWorkflow = void 0;
class BaseWorkflow {
    name;
    description;
    constructor(name, description) {
        this.name = name;
        this.description = description;
    }
}
exports.BaseWorkflow = BaseWorkflow;
